/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S4_QuoteInputs */

const tr_iade_iptal_s4_quote = /** @type {(inputs: Iade_Iptal_S4_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Hizmetin ifasına ödeme onayının ardından derhal başlanmasını açık rızamla talep ediyorum; cayma hakkımın, hizmetin bu onayım doğrultusunda fiilen başlamasıyla sona ereceğini biliyorum (Mesafeli Sözleşmeler Yönetmeliği m. 15/1-h)."`)
};

const en_iade_iptal_s4_quote = /** @type {(inputs: Iade_Iptal_S4_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"I expressly request that performance of the service begin immediately after payment confirmation; I understand that my right of withdrawal ends once the service has actually begun in line with this consent (Article 15/1-h of the Distance Contracts Regulation)."`)
};

const de_iade_iptal_s4_quote = /** @type {(inputs: Iade_Iptal_S4_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Ich verlange ausdrücklich, dass die Leistung unmittelbar nach der Zahlungsbestätigung beginnt; mir ist bekannt, dass mein Widerrufsrecht erlischt, sobald die Leistung aufgrund dieser Zustimmung tatsächlich begonnen hat (Art. 15/1-h der Verordnung über Fernabsatzverträge)."`)
};

const ru_iade_iptal_s4_quote = /** @type {(inputs: Iade_Iptal_S4_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Я прямо прошу начать оказание услуги сразу после подтверждения оплаты; мне известно, что моё право на отказ прекращается с момента фактического начала оказания услуги в соответствии с этим согласием (ст. 15/1-h Положения о дистанционных договорах)."`)
};

/**
* | output |
* | --- |
* | "\"I expressly request that performance of the service begin immediately after payment confirmation; I understand that my right of withdrawal ends once the ser..." |
*
* @param {Iade_Iptal_S4_QuoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s4_quote = /** @type {((inputs?: Iade_Iptal_S4_QuoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S4_QuoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s4_quote(inputs)
	if (locale === "de") return de_iade_iptal_s4_quote(inputs)
	if (locale === "ru") return ru_iade_iptal_s4_quote(inputs)
	return tr_iade_iptal_s4_quote(inputs)
});